import { render, staticRenderFns } from "./commonHelpPopup.vue?vue&type=template&id=744bfda6&scoped=true"
import script from "./commonHelpPopup.vue?vue&type=script&lang=js"
export * from "./commonHelpPopup.vue?vue&type=script&lang=js"
import style0 from "./commonHelpPopup.vue?vue&type=style&index=0&id=744bfda6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744bfda6",
  null
  
)

export default component.exports